import { GenIcon } from '../helpers/IconBase.es.js';

const DiscountOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.5 12.0004C4.5 7.85804 7.85804 4.5 12.0004 4.5C16.1428 4.5 19.5008 7.85804 19.5008 12.0004C19.5008 16.1428 16.1428 19.5008 12.0004 19.5008C7.85804 19.5008 4.5 16.1428 4.5 12.0004ZM12.0004 3C7.02962 3 3 7.02962 3 12.0004C3 16.9712 7.02962 21.0008 12.0004 21.0008C16.9712 21.0008 21.0008 16.9712 21.0008 12.0004C21.0008 7.02962 16.9712 3 12.0004 3ZM8.25005 8.99964C8.25005 8.58538 8.58587 8.24956 9.00012 8.24956C9.41438 8.24956 9.7502 8.58538 9.7502 8.99964C9.7502 9.41389 9.41438 9.74971 9.00012 9.74971C8.58587 9.74971 8.25005 9.41389 8.25005 8.99964ZM9.00012 6.74956C7.75744 6.74956 6.75005 7.75696 6.75005 8.99964C6.75005 10.2423 7.75744 11.2497 9.00012 11.2497C10.2428 11.2497 11.2502 10.2423 11.2502 8.99964C11.2502 7.75696 10.2428 6.74956 9.00012 6.74956ZM14.9999 14.25C14.5856 14.25 14.2498 14.5859 14.2498 15.0001C14.2498 15.4144 14.5856 15.7502 14.9999 15.7502C15.4141 15.7502 15.7499 15.4144 15.7499 15.0001C15.7499 14.5859 15.4141 14.25 14.9999 14.25ZM12.7498 15.0001C12.7498 13.7574 13.7572 12.75 14.9999 12.75C16.2426 12.75 17.2499 13.7574 17.2499 15.0001C17.2499 16.2428 16.2426 17.2502 14.9999 17.2502C13.7572 17.2502 12.7498 16.2428 12.7498 15.0001ZM15.5309 9.53008C15.8237 9.23718 15.8237 8.76231 15.5309 8.46942C15.238 8.17652 14.7631 8.17652 14.4702 8.46942L8.4699 14.4697C8.17701 14.7626 8.17701 15.2375 8.4699 15.5304C8.7628 15.8233 9.23767 15.8233 9.53056 15.5304L15.5309 9.53008Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { DiscountOutlined };
